<div class="content-wrapper">
    <div class="row">
  
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
  
          <div class="card-body">
            <h4 class="card-title">System Users</h4>
         
  
            <div class="card">
  
              <p>Count: {{size}}</p>
              <p-table #dt2 [value]="profiles" dataKey="id" [rows]="10" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10,25,50]" [loading]="loading" [paginator]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [(contextMenuSelection)]="selectedUSer" [contextMenu]=""
                [globalFilterFields]="['firstname','email','lastname','designationName']">
                <ng-template pTemplate="caption">
  
                  <div class="form-group">
                    <div class="input-group">
                      <input type="text" class="form-control" placeholder="search" aria-label="Recipient's username"
                        (input)="dt2.filterGlobal($event.target.value, 'contains')">
                      <div class="input-group-append">
                        <button class="btn btn-sm btn-primary" type="button">Search</button>
                      </div>
                    </div>
                  </div>
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
                  </div>
  
             
                </ng-template>
  
                <ng-template pTemplate="header">
  
                  <tr>
              
                    <th>Name</th>
                    <th>Email</th>
                    <th>Designation</th>
                 
                    <th>
                      Action
                    </th>
  
                  </tr>
  
                  <tr>
                    <th></th>
  
                    <th></th>
  
                    <th></th>
  
                    <th></th>
   
  
                
                   
  
                  </tr>
  
                </ng-template>
  
                <ng-template pTemplate="body" let-data>
                  <tr   >
  
                   
                    <td>
                      {{data.firstName}}  {{data.lastName}}
                    </td>
  
                    <td>
                      {{data.email}}
                    </td>
  
                    <td>
                      {{data.designationName}}
                    </td>
  
                                
  
                    <td>
                      <div class="dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuIconButton6" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                         
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton6">
                 
                          
                              <a class="dropdown-item" (click)="openUser(data)">View User</a>
                              <div class="dropdown-divider"></div>
                          <a class="dropdown-item"  nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                          (nzOnConfirm)="beginDeactivate(data)" (nzOnCancel)="cancel()">Deactivate</a>
  
                        
                      
                        </div>
                      </div>
                  </td>
                  </tr>
                </ng-template>
  
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5">No User found.</td>
                  </tr>
                </ng-template>
  
              </p-table>
            </div>
          </div>
        </div>
      </div>
  
  
  
    </div>
  </div>


  <!-- Drawer -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="720"
[nzVisible]="ViewUserVisible" nzTitle="Create" [nzFooter]="footerTpl" (nzOnClose)="close()">

<!-- Side swipe content -->
<div class="row">
  <div class="col-lg-12 grid-margin stretch-card">
    <div class="card">
      <h5 class="card-title">User Details</h5>
      <div class="card-body">
        <div class="row">

          <div class="col">
            <label><b>Name</b></label>
            <p>{{ selectedUSer?.firstName }} {{ selectedUSer?.lastName }}</p>
          </div>

          <div class="col">
            <label><b>Email</b></label>
            <p>{{ selectedUSer?.email }}</p>
          </div>
        </div>

        <div class="row">

          <div class="col">
            <label><b>Designation</b></label>
            <p>{{ selectedUSer?.designationName }}</p>
          </div>

          <div class="col">
            <label><b>Function</b></label>
            <p>{{ selectedUSer?.departmentName }}</p>
          </div>

        </div>

        <div class="row">

          <div class="col">
            <label><b>Phone</b></label>
            <p>{{ selectedUSer?.phoneNumber }}</p>
          </div>

         

        </div>


      

        
      </div>

      <hr>

      <div class="card">
        <div class="card-body">
          <h4 class="card-title">User Roles</h4>
          <div class="table-responsive pt-3">

            <button style="float: right;"  class="btn btn-primary btn-sm"   (click)="openNewRoleModal(content)"
            >Add New Role</button>
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>
                    S/N
                  </th>

                  <th>
                   Role Name
                  </th>
                  <th>
                    
                  </th>
               
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of Roles; let i = index">
                  
                  <td style="width:0px;">
                    {{i + 1}}
                  </td>

                  <td>
                    {{data.roleName}}
                  </td>

                  <td>
                    <button type="button" class="btn btn-primary btn-sm"
                    nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                        (nzOnConfirm)="removeRole(data)" (nzOnCancel)="cancel()" 

                    >Remove</button>
                  </td>
               
             
                  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
</div>
</div>

<!-- Side swipe content -->

<ng-template #footerTpl>
  <div style="float: right">
    <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;"
    (click)="close()">Cancel</button>


  </div>
</ng-template>

</nz-drawer>
<!-- Drawer -->




<!-- Add Role Modal  -->
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Role</h4>
  </div>
  <div class="modal-body">
 
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">

            

            <!-- select ROle -->
            <div class="row">
              
                <label><b>Role</b></label>
             
             
            </div>
            <div class="row">
              <div    style="width: 100%" >
                <p-multiSelect [options]="allowedRoles" [(ngModel)]="listOfSelectedValue" defaultLabel="Select a Role" optionLabel="roleName" selectedItemsLabel="{0} roles selected" ></p-multiSelect>
              </div>

            </div>


          </div>
        </div>
      </div>
   
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="addRole()">Add</button>
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>
<!-- Add New Role Modal End -->